var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 39.42,
    viewBox: "0 0 38 39.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #002c5f;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18765",
    "data-name": "Group 18765",
    transform: "translate(-1442 -8099)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18397",
    "data-name": "Rectangle 18397",
    className: "cls-1",
    width: 38,
    height: 38.905,
    rx: 5,
    transform: "translate(1442 8099)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7559",
    "data-name": "Path 7559",
    className: "cls-2",
    d: "M55.216,43.691l.854-5.573H50.723V34.5c0-1.525.746-3.011,3.142-3.011H56.3V26.747a29.589,29.589,0,0,0-4.316-.377c-4.4,0-7.284,2.668-7.284,7.5v4.247H39.8v5.573h4.9V58.024a19.5,19.5,0,0,0,6.027,0V43.691h4.493Z",
    transform: "translate(1413.367 8080.162)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebook);
export default __webpack_public_path__ + "static/media/Icon_Facebook.a5f5836c2156a52a807e60fe0125a2c5.svg";
export { ForwardRef as ReactComponent };